import { JDSFileUploaderListProps } from './generated/interface';

export const withLogic =
  (
    Component: React.ComponentType<JDSFileUploaderListProps>
  ): React.FC<JDSFileUploaderListProps> =>
  (props: JDSFileUploaderListProps) => {
    return <Component {...props} />;
  };
